module.exports = __webpack_public_path__ + "static/media/chas-logo.0d08d60c.svg";